"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var styles = function styles(theme) {
  return {
    root: {},
    rightBar: (0, _defineProperty2.default)({
      alignSelf: "flex-start",
      width: "100%"
    }, theme.breakpoints.up("md"), {
      top: theme.spacing(1),
      position: "sticky"
    })
  };
};

exports.styles = styles;